import { Component, ViewContainerRef } from '@angular/core';
import { Router, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { AccountApi,AppApi } from './shared/sdk/services/custom';
import { LoopBackConfig } from './shared/sdk/index';
import {PlatformApp} from './shared/services/app.service';
import { BASE_URL, API_VERSION } from '../environments/environment';
import { LoopBackAuth } from './shared/sdk/services/core/auth.service';

@Component({
  selector: 'body',
  template: `<router-outlet></router-outlet>
            <simple-notifications [options]="notifyOptions"></simple-notifications>
          `
})
//export class AppComponent { }

export class AppComponent {
  private viewContainerRef: ViewContainerRef;
  
  notifyOptions = PlatformApp.getNotificationOptions();

  public constructor(viewContainerRef: ViewContainerRef, private _router: Router,
  private auth: LoopBackAuth,private _AppApi:AppApi,
   private _account: AccountApi,private _PlatformApp:PlatformApp) {

    //Set the url for the loopback api 
    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    // You need this small hack in order to catch application root view container ref
    this.viewContainerRef = viewContainerRef;
    /*
    this._router.events.subscribe((e) => {
      if (e instanceof NavigationStart && e.url !== '/login' && !this._account.isAuthenticated()) {
        this._router.navigate(['/login']);
      } 
      if(e instanceof NavigationStart && e.url === '/' && this._account.isAuthenticated()){
        //The user is trying to reach the app's main page. send him there
        console.log('Send to main page');
      }
    });
    */
  }

/*
In the AppComponent, load the basic app details and route the application to main page of the app that is being requested
*/

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts